import React from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "../css/Infrastructure.css";

// Example images – replace these with your own paths
import labImg from "../img/lab.jpg";
import classroomImg from "../img/classroom.jpg";
import workshopImg from "../img/workshop.jpg";
import libraryImg from "../img/library.jpg";

const infrastructureItems = [
  {
    title: "Electrical Lab",
    desc: "Equipped with modern tools and components for practical electrical training.",
    img: labImg,
  },
  {
    title: "Workshop",
    desc: "Spacious and well-maintained area for hands-on sessions and real-world learning.",
    img: workshopImg,
  },
  {
    title: "Smart Classrooms",
    desc: "Digital classrooms with projectors and e-learning tools for interactive education.",
    img: classroomImg,
  },
  {
    title: "Library",
    desc: "A well-stocked library offering technical books, journals, and study materials.",
    img: libraryImg,
  },
];

const Infrastructure = () => {
  return (
    <section className="infrastructure-section py-5">
      <div className="container">
        <h2 className="section-title text-center mb-5">
          Our <span>Infrastructure</span>
        </h2>
        <div className="row g-4">
          {infrastructureItems.map((item, index) => (
            <div className="col-lg-3 col-md-6 col-sm-12" key={index}>
              <div className="infra-card">
                <div className="infra-img">
                  <img src={item.img} alt={item.title} className="img-fluid" />
                  <div className="infra-overlay">
                    <p>{item.desc}</p>
                  </div>
                </div>
                <h5 className="infra-title mt-3">{item.title}</h5>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Infrastructure;
